import { SharedModule } from '@app/shared/shared.module';
import { SignUpFormModule } from '../sign-up/sign-up-form/sign-up-form.module';
import { NgModule } from '@angular/core';
import { LandingPageComponent } from './landing-page.component';
import { LandingPageRoutingModule } from './landing-page-routing.module';
import { DialogSearchWaterways } from './dialog-search-waterways/dialog-search-waterways';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeedModule } from '@app/modules';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SignUpModule } from '../sign-up/sign-up.module';
import { MapFeaturesComponent } from './map-features/map-features.component';
import { FindWaterwaysComponent } from './find-waterways/find-waterways.component';
import { LandingActivityComponent } from './activity/activity.component';
import { PopularWaterwaysComponent } from './popular-waterways/popular-waterways.component';
import { FeaturedAnglersComponent } from './featured-anglers/featured-anglers.component';

@NgModule({
  declarations: [
    LandingPageComponent,
    DialogSearchWaterways,
    MapFeaturesComponent,
    FindWaterwaysComponent,
    LandingActivityComponent,
    PopularWaterwaysComponent,
    FeaturedAnglersComponent,
  ],
  imports: [SharedModule, SignUpFormModule, LandingPageRoutingModule, MatTooltipModule, FeedModule, CarouselModule, SignUpModule],
  exports: [LandingPageComponent],
})
export class LandingPageModule {}
